import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

const state = {
    curHouseInfo: Object,
    isShowHouse: false,
}

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations
});


// WEBPACK FOOTER //
// ./src/store/storeMain.js